import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
	List,
	Popup
} from 'semantic-ui-react';

import { log } from '../../../services/utils';

const ConfirmInstructionsPopup = ( {
	confirm,
	context,
	open,
	password
} ) => {
	const setColor = () => {
		if ( !confirm ) {
			return null;
		}

		return password === confirm
			? 'green'
			: 'red';
	};

	const setIcon = () => {
		if ( !confirm ) {
			return 'circle outline';
		}

		return password === confirm
			? 'check circle outline'
			: 'times circle outline';
	};

	return (
		<Popup
			context={ context }
			inverted
			open={ password && open }
			position="top center"
			size="small"
			style={ { opacity: 0.95 } }
		>
			{ log( '- confirmInstructionsPopup' ) }
			<Popup.Content>
				<List>
					<List.Content>
						<List.Item
							style={ {
								display: 'flex',
								alignItems: 'center'
							} }
						>
							<List.Icon
								color={ setColor() }
								name={ setIcon() }
							/>
              &nbsp;
              Passwords must match
						</List.Item>
					</List.Content>
				</List>
			</Popup.Content>
		</Popup>
	);
};

ConfirmInstructionsPopup.propTypes = {
	confirm: PropTypes.string.isRequired,
	context: PropTypes.object.isRequired,
	open: PropTypes.bool.isRequired,
	password: PropTypes.string.isRequired
};

export default memo( ConfirmInstructionsPopup );
